import { withTranslation } from 'react-i18next';

import ReactSelect from '../../../../components/ReactSelect';
import { GRID_SELECT } from '../../GscTools/selectStyles';
import { groupsFrom } from '../groups';
import { MODES, ORDER_METRICS } from '../scope';

/**
 * This report's own scope controls, laid out in the shared control grid beside the property and
 * the dates: which group the trend and the matching URLs are about, how the groups are ordered,
 * and which metric that order reads.
 *
 * The group list is the session's own groups, read from the rules being written below — there is
 * nothing to pick until a group exists, and a group that has been typed but not applied is
 * already pickable, because Apply sends the two together.
 */
function ExtraControls({ t, draft, onChange }) {
    const groupOptions = groupsFrom(draft.rules).map((group) => ({
        value: group.name,
        label: group.name,
    }));
    const groupValue =
        groupOptions.find((item) => item.value === draft.group) ?? groupOptions[0] ?? null;

    const modeOptions = MODES.map((value) => ({
        value,
        label: t(`tools.content_groups.modes.${value}`),
    }));
    const metricOptions = ORDER_METRICS.map((value) => ({
        value,
        label: t(`tools.gsc.metrics.${value}_short`),
    }));

    return (
        <>
            <div className="gsc-tool-field">
                <label>{t('tools.content_groups.controls.group')}</label>
                <ReactSelect
                    options={groupOptions}
                    value={groupValue}
                    blurInputOnSelect={true}
                    disabled={!groupOptions.length}
                    placeholder={t('tools.content_groups.controls.group_none')}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ group: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.content_groups.controls.group_note')}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.content_groups.controls.mode')}</label>
                <ReactSelect
                    options={modeOptions}
                    value={modeOptions.find((item) => item.value === draft.mode)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ mode: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t(`tools.content_groups.controls.mode_note.${draft.mode}`)}
                </span>
            </div>

            <div className="gsc-tool-field">
                <label>{t('tools.content_groups.controls.metric')}</label>
                <ReactSelect
                    options={metricOptions}
                    value={metricOptions.find((item) => item.value === draft.metric)}
                    blurInputOnSelect={true}
                    classname="gsc-tool-select"
                    controlStyles={GRID_SELECT}
                    customeOnChange={(item) => onChange({ metric: item.value })}
                />
                <span className="gsc-tool-field-note">
                    {t('tools.content_groups.controls.metric_note')}
                </span>
            </div>
        </>
    );
}

export default withTranslation()(ExtraControls);
